import { render, staticRenderFns } from "./CustomPInput.vue?vue&type=template&id=5475ea19&scoped=true&"
import script from "./CustomPInput.vue?vue&type=script&lang=js&"
export * from "./CustomPInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomPInput.vue?vue&type=style&index=0&id=5475ea19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475ea19",
  null
  
)

export default component.exports